import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import RootStateTypes, { AllStateTypes } from './interface'

import XTXModel from './modules/XTXScoket'
import testModel from './modules/test'

// 确保 Vuex 已注册
Vue.use(Vuex)

export const store = new Vuex.Store<RootStateTypes>({
  modules: {
    XTXModel,
    testModel
  },
  plugins: [
      createPersistedState({
          storage: window.sessionStorage,
          paths: ["XTXModel.curUserCertId"]
      })
  ],
})

// 定义自己的 `useStore` 组合式函数
export function useStore <T=AllStateTypes>(): Store<T> {
  return store as Store<T>
}